import { validateInvoiceStatus } from "@/types/invoiceStatus";
import { useEffect, useState } from "react";
import { StyledTableBisManualPag } from "@/components/styled/StyledTableBisManualPag";

import { InvoiceValidationModal } from "../invoiceValidationModal";
import { InvoiceDeletionModal } from "../invoiceDeletionModal";
import usePagination from "@/hooks/useSyncedPagination";
import { InvoiceDto } from "@/types/api/api-types";
import { useLitigeTableColumns } from "./litigeTableColumns";
import { LitigesFilter } from "./litigesFilter";
import { useGetLitigeBoV1 } from "@/api/invoice";
import { useDisplayDocument } from "@/hooks/useDisplayDocument";
import { InvoiceStatusEnum } from "@/constants/enums/invoiceStatus.enum";
import { userAtom } from "@/stores/authStore";
import { useAtomValue } from "jotai";

type InvoiceTableProps = {
  companyId?: string;
};

export const LitigeTable = ({ companyId }: InvoiceTableProps) => {
  const [searchField, setSearchField] = useState<string>("");
  const [statusField, setStatusField] = useState<string>("");
  const [pagination, setPagination] = usePagination("litigeBo");
  const [invoiceDeleteModal, setInvoiceDeleteModal] = useState<string | null>(null);
  const [selectedInvoice, setSelectedInvoice] = useState<InvoiceDto | null>(null);

  const user = useAtomValue(userAtom);

  const { displayDocument } = useDisplayDocument();

  const { data: litiges } = useGetLitigeBoV1({
    paymentStatus: statusField ? validateInvoiceStatus(statusField) : undefined,
    invoiceId: searchField ? searchField : undefined,
    businessName: searchField ? searchField : undefined,
    companyId: companyId || undefined,
    take: pagination.pageSize,
    skip: pagination.pageIndex * pagination.pageSize,
    status: [InvoiceStatusEnum.VALIDATED],
  });

  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      pageIndex: 0,
    }));
  }, [setPagination, searchField, statusField, companyId]);

  const columns = useLitigeTableColumns(
    displayDocument,
    setSelectedInvoice,
    setInvoiceDeleteModal,
    user?.role || null,
  );

  return (
    <>
      <LitigesFilter
        setSearchField={setSearchField}
        searchField={searchField}
        setStatusField={setStatusField}
        statusField={statusField}
      />
      <StyledTableBisManualPag
        data={litiges?.data || []}
        columns={columns}
        setPagination={setPagination}
        pagination={pagination}
        rowCount={litiges?.count || 0}
      />
      <InvoiceValidationModal
        closeModal={() => setSelectedInvoice(null)}
        invoice={selectedInvoice}
      />
      <InvoiceDeletionModal
        closeModal={() => setInvoiceDeleteModal(null)}
        id={invoiceDeleteModal}
      />
    </>
  );
};
